import { useSelector } from "react-redux";

import classes from "./Loader.module.scss";

import { isLoaderActive } from "@/features/loader/loaderSlice";

const Loader = () => {
  const loader = useSelector(isLoaderActive);
  return (
    loader && (
      <div className={classes.cover}>
        <div className={classes.loading}>
          <span>Loading</span>
          <div className={classes.ldsDualRing} />
        </div>
      </div>
    )
  );
};

export default Loader;
